/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1XIcon16Light } from './People1XIcon16Light';
import { People1XIcon16Regular } from './People1XIcon16Regular';
import { People1XIcon16Solid } from './People1XIcon16Solid';
import { People1XIcon20Light } from './People1XIcon20Light';
import { People1XIcon20Regular } from './People1XIcon20Regular';
import { People1XIcon20Solid } from './People1XIcon20Solid';
import { People1XIcon24Regular } from './People1XIcon24Regular';
import { People1XIcon24Solid } from './People1XIcon24Solid';
import { People1XIcon32Regular } from './People1XIcon32Regular';
import { People1XIcon64Regular } from './People1XIcon64Regular';
var sizes = {
    16: {
        light: People1XIcon16Light,
        regular: People1XIcon16Regular,
        solid: People1XIcon16Solid,
    },
    20: {
        light: People1XIcon20Light,
        regular: People1XIcon20Regular,
        solid: People1XIcon20Solid,
    },
    24: {
        regular: People1XIcon24Regular,
        solid: People1XIcon24Solid,
    },
    32: {
        regular: People1XIcon32Regular,
    },
    64: {
        regular: People1XIcon64Regular,
    },
};
export var People1XIcon = forwardRef('People1XIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
